"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.googleDriveCreateFolder = exports.googleDriveCreateFolderResultSchema = exports.googleDriveCreateFolderArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
exports.googleDriveCreateFolderArgsSchema = (0, common_1.PipedreamNodeArgsSchema)('create-folder', zod_1.z.object({
    name: zod_1.z
        .string()
        .nullish()
        .describe("The folder's name (default to 'New Folder' if not provided)"),
}));
var googleDriveFileSchema = zod_1.z.object({
    kind: zod_1.z.string().describe('Identifies what kind of resource this is'),
    mimeType: zod_1.z.string().describe('The MIME type of the file'),
    name: zod_1.z.string().describe('The name of the file'),
    id: zod_1.z.string().describe('The id of this file'),
});
exports.googleDriveCreateFolderResultSchema = (0, common_1.PipedreamNodeResultSchema)(googleDriveFileSchema);
exports.googleDriveCreateFolder = (0, common_1.createToolMetadata)({
    id: 'googleDriveCreateFolder',
    displayName: 'Google Drive Create Folder',
    displayDescription: 'Create a new folder in Google Drive',
    category: 'integration',
    color: common_1.BRAND_COLORS.GOOGLE_DRIVE,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.GOOGLE_DRIVE),
    icon: 'google_drive',
    argsSchema: exports.googleDriveCreateFolderArgsSchema,
}, exports.googleDriveCreateFolderResultSchema);
